<template>
  <div class="grid grid-cols-2 p-2">
    <MenuFoodCard
      v-for="food in foods.specialCategoryDetail"
      :key="food.id"
      :food="food"
    />
  </div>
</template>

<script>
import { getSpecialCategory } from "@/API/API";
import MenuFoodCard from "@/components/MenuFoodCard";

export default {
  name: "SpecialCategory",
  components: { MenuFoodCard },
  data() {
    return {
      categories: [],
      foods: {},
      selectedCategory: {},
    };
  },
  async created() {
    this.foods = (await getSpecialCategory(this.$route.params.id)).data.result;
  },
};
</script>

<style></style>
